<template>
  <el-dialog
    title="设置优先级"
    :visible.sync="visible"
    width="360px"
    append-to-body
    :close-on-press-escape="false"
    :close-on-click-modal="false"
    @closed="handleClosed"
  >
    <el-form
      ref="ruleForm"
      :model="info"
      :rules="rules"
      label-width="95px">
      <el-form-item label="培训名称：">{{ info.videoName }}</el-form-item>
      <el-form-item
        label="优先级："
        prop="sortValue">
        <el-input-number
          v-model="info.sortValue"
          :precision="0"
          :max="100000"></el-input-number>
      </el-form-item>
    </el-form>
    <span slot="footer">
      <el-button
        :loading="loading"
        @click="toggleModal(false)">
        取 消
      </el-button>
      <el-button
        type="primary"
        :loading="loading"
        @click="handleSubmit">
        更新
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: 'SortValueModal',
  components: { },
  props: {
    callback: {
      type: Function
    }
  },
  data() {
    return {
      loading: false,
      visible: false,
      info: {
        trainingVideoId: null,
        videoName: '',
        sortValue: ''
      },
      rules: {
        sortValue: [
          { required: true, message: '请输入优先级', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    toggleModal(visible) {
      this.visible = visible
    },
    handleClosed() {
      this.info = {
        trainingVideoId: null,
        videoName: '',
        sortValue: ''
      }
      this.$refs.ruleForm.resetFields()
    },
    handleSubmit() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.loading = true
          this.$store.dispatch(`account/updatetrainingvideo`, {
            payload: {
              ...this.info
            },
            success: () => {
              this.$message.success('设置成功')
              this.loading = false
              this.toggleModal(false)
              this.callback && this.callback()
            },
            fail: () => {
              this.loading = false
            }
          })
        }
      })
    },
    update(options = {}) {
      this.info = {
        ...this.info,
        ...options
      }
      this.toggleModal(true)
    }
  }
}
</script>
